// extracted by mini-css-extract-plugin
export var container = "_bm-0";
export var containerTopRight = "_bm-1";